import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const P_SOUCHEVENTE_SCHEMA_LITERAL = {
    title: 'Schéma SoucheVente',
    description: 'Décrit une souche vente',
    version: 0,
    keyCompression: false,
    primaryKey: 'DO_SOUCHE_STR',
    type: 'object',
    properties: {
        DO_SOUCHE_STR: { type: 'string', maxLength : 20 },
        DO_SOUCHE: { type: 'number' },
        SV_INTITULE: { type: 'string' },
        SV_PRINCIPAL_PSITE: { type: 'boolean' },
        SV_PRINCIPAL_F: { type: 'boolean' }
    },
    required: [ 'DO_SOUCHE', 'SV_INTITULE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(P_SOUCHEVENTE_SCHEMA_LITERAL);
export type RxPSoucheVenteDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const P_SOUCHEVENTE_SCHEMA: RxJsonSchema<RxPSoucheVenteDocumentType> = P_SOUCHEVENTE_SCHEMA_LITERAL;
